import { chartTooltip } from "./util";

export const lineChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      grid: {
        display: true,
        lineWidth: 1,
        color: "rgba(0,0,0,0.1)",
        drawBorder: false,
      },
      ticks: {
        stepSize: 50,
        padding: 20,
      },
    },
    x: {
      grid: {
        display: false,
      },
    },
  },
};

export const polarAreaChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        padding: 30,
        usePointStyle: true,
        font: {
          size: 12,
        },
      },
    },
    datalabels: {
      display: false,
    },
    tooltip: chartTooltip,
  },
  scales: {
    r: {
      ticks: {
        display: false,
      },
    },
  },
};

export const areaChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: chartTooltip,
  },
  scales: {
    y: {
      beginAtZero: true,
      grid: {
        display: true,
        lineWidth: 1,
        color: "rgba(0,0,0,0.1)",
        drawBorder: false,
      },
      ticks: {
        stepSize: 5,
        padding: 20,
      },
    },
    x: {
      grid: {
        display: false,
      },
    },
  },
};

export const scatterChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        padding: 30,
        usePointStyle: true,
        font: {
          size: 12,
        },
      },
    },
    tooltip: chartTooltip,
  },
  scales: {
    y: {
      beginAtZero: true,
      min: -80,
      max: 80,
      grid: {
        display: true,
        lineWidth: 1,
        color: "rgba(0,0,0,0.1)",
        drawBorder: false,
      },
      ticks: {
        stepSize: 20,
        padding: 20,
      },
    },
    x: {
      grid: {
        display: true,
        lineWidth: 1,
        color: "rgba(0,0,0,0.1)",
      },
    },
  },
};

export const barChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: chartTooltip,
  },
  scales: {
    y: {
      beginAtZero: true,
      grid: {
        display: true,
        lineWidth: 1,
        color: "rgba(0,0,0,0.1)",
        drawBorder: false,
      },
      ticks: {
        padding: 20,
        stepSize: 25,
      },
    },
    x: {
      grid: {
        display: false,
      },
    },
  },
};

export const radarChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        padding: 30,
        usePointStyle: true,
        font: {
          size: 12,
        },
      },
    },
    tooltip: chartTooltip,
  },
  scales: {
    r: {
      ticks: {
        display: false,
      },
    },
  },
};

export const pieChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    tooltip: chartTooltip,
  },
  layout: {
    padding: {
      bottom: 20,
    },
  },
};

export const doughnutChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        padding: 30,
        usePointStyle: true,
        font: {
          size: 12,
        },
      },
    },
    title: {
      display: false,
    },
    tooltip: chartTooltip,
  },
  cutout: "80%",
  layout: {
    padding: {
      bottom: 20,
    },
  },
};

export const smallLineChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: chartTooltip,
  },
  layout: {
    padding: {
      left: 5,
      right: 5,
      top: 10,
      bottom: 10,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      display: false,
    },
    x: {
      display: false,
    },
  },
};
